import { useEffect, useState } from "react";
import { FolderPlus, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const CreateFolderDialog = ({ onCreate, onOpenChange, open }) => {
  const [folderName, setFolderName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setFolderName("");
  }, [open]);

  const handleCreate = async () => {
    if (!folderName.trim()) return;
    setLoading(true);
    await onCreate(folderName.trim());
    setLoading(false);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="glass-surface border-sonas-border bg-sonas-surface text-sonas-text p-8 rounded-[32px] max-w-sm shadow-2xl">
        <DialogHeader className="items-center text-center">
          <div className="h-12 w-12 rounded-2xl bg-sonas-accent/10 flex items-center justify-center border border-sonas-accent/20 mb-4">
            <FolderPlus className="h-6 w-6 text-sonas-accent" />
          </div>
          <DialogTitle className="text-2xl font-syne">New Folder</DialogTitle>
          <DialogDescription className="text-xs text-sonas-muted">
            Group your projects into logical architectural sectors.
          </DialogDescription>
        </DialogHeader>

        <div className="py-6 space-y-2">
          <label className="text-[10px] font-bold uppercase tracking-widest text-sonas-dim px-1">Folder Name</label>
          <Input
            autoFocus
            className="h-12 rounded-2xl bg-sonas-surface2 border-sonas-border"
            onChange={(e) => setFolderName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            placeholder="e.g. Combat Systems"
            value={folderName}
          />
        </div>

        <DialogFooter className="sm:flex-col gap-3">
          <Button
            className="w-full h-12 bg-sonas-accent text-sonas-bg font-bold rounded-2xl shadow-lg shadow-sonas-accent/20"
            disabled={!folderName.trim() || loading}
            onClick={handleCreate}
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
            Create Folder
          </Button>
          <Button
            className="w-full h-12 rounded-2xl bg-white/5 border-none"
            onClick={() => onOpenChange(false)}
            variant="ghost"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CreateFolderDialog;